const PRESENTATION_COLLECTION_QUERY_KEY = "collectionId";

const normalizeSearch = (search: string): string => {
  if (!search) {
    return "";
  }
  return search.startsWith("?") ? search.slice(1) : search;
};

export const parsePresentationCollectionId = (search: string): string => {
  const params = new URLSearchParams(normalizeSearch(search));
  return params.get(PRESENTATION_COLLECTION_QUERY_KEY) || "";
};

export const serializePresentationCollectionId = (
  search: string,
  collectionId: string
): string => {
  const params = new URLSearchParams(normalizeSearch(search));
  if (collectionId) {
    params.set(PRESENTATION_COLLECTION_QUERY_KEY, collectionId);
  } else {
    params.delete(PRESENTATION_COLLECTION_QUERY_KEY);
  }
  const next = params.toString();
  return next ? `?${next}` : "";
};

export const resolveCollectionSlides = ({
  collection,
  views,
}: {
  collection:
    | Pick<user_prefs.TeamCanvasViewCollection, "viewIds">
    | null
    | undefined;
  views: user_prefs.TeamCanvasViews;
}): user_prefs.TeamCanvasViews => {
  const viewsById = (views || []).reduce<
    Record<string, user_prefs.TeamCanvasView>
  >((acc, view) => {
    acc[view.id] = view;
    return acc;
  }, {});
  return (collection?.viewIds || [])
    .map((viewId) => viewsById[viewId])
    .filter(Boolean) as user_prefs.TeamCanvasViews;
};
